import PropTypes from 'prop-types';
import sx from '@styled-system/css';
import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import variant from '@styled-system/variant';
import Base from './base';
import { DISABLED_COLOR } from './shared';

const Ghost = styled(Base, { shouldForwardProp })(
  ({ disabled = false }) =>
    sx({
      backgroundColor: 'transparent',
      boxShadow: 'inset 0 0 0 1px currentColor',
      '&[disabled]': {
        cursor: 'not-allowed',
        color: DISABLED_COLOR,
        '&:hover': {
          color: DISABLED_COLOR,
        },
        '&:active': {
          color: DISABLED_COLOR,
        },
      },
      ...(disabled && {
        cursor: 'not-allowed',
        color: DISABLED_COLOR,
        '&:hover': {
          color: DISABLED_COLOR,
        },
        '&:active': {
          color: DISABLED_COLOR,
        },
      }),
    }),
  variant({
    variants: {
      default: {
        color: 'grays.0',
        '&:hover': {
          backgroundColor: 'grays.6',
        },
        '&:active': {
          backgroundColor: 'grays.5',
        },
      },
      primary: {
        color: 'indigos.3',
        backgroundColor: 'grays.7',
        '&:hover': {
          color: 'indigos.1',
          backgroundColor: 'indigos.7',
        },
        '&:active': {
          color: 'indigos.1',
          backgroundColor: 'indigos.6',
        },
      },
      alt: {
        color: 'grays.2',
        backgroundColor: 'grays.7',
        '&:hover': {
          color: 'grays.1',
          backgroundColor: 'grays.6',
        },
        '&:active': {
          color: 'grays.1',
          backgroundColor: 'grays.5',
        },
      },
      light: {
        color: 'grays.7',
        '&:hover': {
          color: 'grays.3',
        },
        '&:active': {
          color: 'grays.2',
        },
      },
    },
  }),
);

Ghost.propTypes = {
  /** content to be rendered inside of the button. Could be text or text paired
   * with an icon.
   */
  children: PropTypes.node.isRequired,
  /** the button style which determines its look */
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(['default', 'primary', 'alt', 'light']),
    PropTypes.arrayOf(PropTypes.oneOf(['default', 'primary', 'alt', 'light'])),
  ]),
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
    PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])),
  ]),
  /** apply this prop if the button isn't interactible */
  disabled: PropTypes.bool,
};

Ghost.defaultProps = {
  size: 'md',
  variant: 'default',
  disabled: false,
};

Ghost.displayName = 'Monterey(Button.Ghost)';
export default Ghost;
